import "./DealGridItemView.css";

function DealGridItemView({ item, onClick }) {
  const logoDisplayMode = item.logo_display_mode || "full_color";
  const usesWhiteFilter = logoDisplayMode === "white_filter";

  return (
    <div
      className={`deal-grid-item ${usesWhiteFilter ? "deal-grid-item--white-filter" : ""}`.trim()}
      onClick={() => onClick(item)}
    >
      <img src={item.brand_image_url} alt={item.brand_name}></img>
    </div>
  );
}

export default DealGridItemView;
